import * as Yup from 'yup';

export const purchaseCreditNoteValidationSchema = Yup.object().shape({
  supplier: Yup.string().required('Supplier is required'),
  creditNoteDate: Yup.date().required('Credit Note Date is required'),
});
export const purchaseCreditNoteInitialValues = {
    supplier: '',
    contact: '',
    supplierAddress1: '',
    location: '',
    terms: '',
    taxRule: '',
    phone: '',
    taxInclusive: false,
    creditNoteDate: '',
    supplierAddress2: '',
  };